import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CaboConcierge from "@/pages/CaboConcierge";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CaboConcierge />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
